import moment from 'moment';
import Segment from '../../Segment';
import Intercom from '../../Intercom';
import DDLogs from '../../DDLogs';
import CustomerApi from '../../api/CustomersApi';
import CustomerActivityApi from '../../api/CustomerActivityApi';
import HansApi from '../../api/HansApi';
import SubscriptionStateApi from '../../api/SubscriptionStateApi';
import router from '../../router/index';
import featureFlag from '../../api/featureFlag';
import InvalidCredentialsStateApi from '../../api/InvalidCredentialsStateApi';

function _getDaysSince(subscriptionState) {
  return moment().diff(moment(subscriptionState.since), 'days');
}

const state = {
  authenticated: false,
  inviteToken: '',
  customerId: null,
  customerDetails: {},
  members: [],
  phoneNumberFromQuery: '',
};

const getters = {
  firstName: state => state.customerDetails.firstName,
  lastName: state => state.customerDetails.lastName,
  secondMemberName: state => state.customerDetails.secondMemberName,
  numberOfMembers: state => state.members.length,
  householdName: state => state.customerDetails.householdName,
  phoneNumberFromQuery: state => state.phoneNumberFromQuery,
  phoneNumber: state => {
    const { phoneNumber } = state.customerDetails;
    return phoneNumber ? `0${phoneNumber.slice(0, 2)}-${phoneNumber.slice(-7)}` : null;
  },
  // numOfMembers: state => state.customerDetails.
};

const actions = {
  async init({ commit, getters }, { incognito, name, phoneNumberFromQuery }) {
    commit('setPhoneNumberFromQuery', phoneNumberFromQuery);
    try {
      const customerDetails = await CustomerApi.getCustomerDetails();
      const onboardingStatus = await CustomerApi.getOnboradingStatus();
      const members = await CustomerApi.getMembers();
      const inviteToken = await HansApi.generateInviteToken();
      const subscriptionState = await SubscriptionStateApi.fetchSubscriptionState();
      const invalidCredentialsState = await InvalidCredentialsStateApi.fetchInvalidCredentialsState();
      // eslint-disable-next-line max-len
      const cxTrialMessagesTest = (await featureFlag.getTreatment('cx-trial-messages', { subscriptionState: subscriptionState.subscriptionState })) === 'on';
      commit('setCustomerId', customerDetails.customerId);
      DDLogs.addGlobalContext('customerId', customerDetails.customerId);
      commit('setAuthenticated', true);
      commit('setCustomerDetails', customerDetails);
      commit('setMembers', members);
      commit('setInviteToken', inviteToken.token);
      Segment.setIncognito(incognito);
      Segment.identifyCustomer(customerDetails.customerId);
      if (!incognito) {
        const isOnboarding = onboardingStatus !== 'completed';
        const daysInTrial = subscriptionState.state === 'trial' ? _getDaysSince(subscriptionState) : undefined;
        const daysInInvalidCredentials = invalidCredentialsState ? Math.abs(moment(invalidCredentialsState.since).diff(moment(), 'days')) : 0;
        await Intercom.boot(
          customerDetails.customerId, getters.householdName,
          {
            userHash: customerDetails.intercomUserHash,
            numberOfMembers: getters.numberOfMembers,
            isOnboarding,
            daysInTrial,
            cxTrialMessagesTest,
            daysInInvalidCredentials,
          },
        );
        await CustomerActivityApi.setCustomerActivity({
          activityTime: moment(),
          details: {
            activityType: 'visitPage',
            pageName: name,
          },
        });
      }

      const { showIntercom } = router.currentRoute.query;
      if (showIntercom) {
        Intercom.show();
      }
    } catch (e) {
      // Added this in order to avoid sentry issues ith 403 errors
      console.log('Could not authenticate', e);
    }
  },
  setAuthenticated({ commit }, value) {
    commit('setAuthenticated', value);
  },
};

const mutations = {
  setAuthenticated(state, authenticateRespond) {
    state.authenticated = authenticateRespond; // eslint-disable-line
  },
  setCustomerId(state, customerId) {
    state.customerId = customerId; // eslint-disable-line
  },
  setCustomerDetails(state, customerDetails) {
    state.customerDetails = customerDetails; // eslint-disable-line
  },
  setMembers(state, members) {
    state.members = members; // eslint-disable-line
  },
  setInviteToken(state, inviteToken) {
    state.inviteToken = inviteToken; // eslint-disable-line
  },
  setPhoneNumberFromQuery(state, phoneNumber) {
    state.phoneNumberFromQuery = phoneNumber; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
